// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__-i0d7","content":"styles_content__3vMTS","selectAll":"styles_selectAll__2dZDK"};